import { IconButton, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { EditWorkoutApi } from "src/DAL/workout/workout";
import TinyEditor from "src/components/ckeditor/Ckeditor";

const EditCommentSet = () => {
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [commentContent, setCommentContent] = useState("");

  useEffect(() => {
    if (state?.comment) {
      setCommentContent(state.comment);
    }
  }, [state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!commentContent || commentContent.trim() === "") {
      enqueueSnackbar("Please enter comment content", { variant: "error" });
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("title", state.title);
    formData.append("practice_type", "comment");
    formData.append("comment", commentContent);
    formData.append("type", state.type);
    formData.append(
      "description",
      state.description || state.short_description || "",
    );
    formData.append("status", state.status);
    formData.append(
      "difficulty_levels",
      JSON.stringify(state?.difficulty_levels || []),
    );
    formData.append("exercises", JSON.stringify([]));
    formData.append("workout_note", state?.workout_note || "");

    const result = await EditWorkoutApi(formData, state.workout_slug);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      navigate(-1);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row mt-3 align-items-center">
        <div className="col-12 col-md-12">
          <div className="d-flex align-items-center">
            <IconButton
              className="back-screen-button mb-0"
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
            <h1 className="programmes-heading ms-2">{state?.title}</h1>
          </div>
        </div>
        {(state?.description || state?.short_description) && (
          <div className="col-12 section-space">
            <div
              dangerouslySetInnerHTML={{
                __html: state?.description || state?.short_description,
              }}
            />
          </div>
        )}
        <div className="col-12 mt-3 mb-3">
          <TextField
            id="comment-text"
            label="Write your comment here"
            placeholder="Write your comment here"
            variant="outlined"
            fullWidth
            multiline
            rows={6}
            name="comment"
            value={commentContent}
            onChange={(e) => {
              setCommentContent(e.target.value);
            }}
          />
        </div>
        <div className="text-end mt-4">
          <button className="small-contained-button" onClick={handleSubmit}>
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCommentSet;
